'use client';

import { removeCookie } from '@cat-ecom/common/utils/cookieUtils';
import { WC_GUEST_SESSION } from 'constants/storageConstants';

export const useLogin = () => {
  const removeGuestCookies = () => {
    removeCookie(WC_GUEST_SESSION);
  };

  return { removeGuestCookies };
};
